import { Component, Inject, OnInit } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { BottomSheetFilter, CheckList, CheckOptionState } from '@core/models/bottom-sheet-filter';
import { isFalsyValue } from '@shared/utils/object';
import { format, parseISO } from 'date-fns';
import { TRANSLOCO_SCOPE } from '@ngneat/transloco';

@Component({
  selector: 'app-filter-bottom-sheet',
  templateUrl: './filter-bottom-sheet.component.html',
  styleUrls: ['./filter-bottom-sheet.component.scss']
})
export class FilterBottomSheetComponent implements OnInit {
  optionsState: CheckOptionState[];

  showDatePicker: boolean = false;
  dateFilterLabel: string;

  isDateFilterExpanded: boolean = false;

  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: BottomSheetFilter,
    @Inject(TRANSLOCO_SCOPE) public translationScope: string,
    private bottomSheetRef: MatBottomSheetRef<FilterBottomSheetComponent>
  ) { }

  ngOnInit(): void {
    this.getDateFilterLabel();
    this.getOptionsState(this.data.filters);
  }

  updateSearchFilter(searchText: string) {
    this.data.search.value = searchText;
  }

  resetFiltersAndSearch(): void {
    this.data.resetAll = true;
    this.closeBottomSheet();
  }

  getOptionsState(filters: CheckList[]) {
    this.optionsState = filters.map(({options}) => ({
      total: options.length,
      visible: 3
    }));
  }

  toggleButton(filterIndex: number) {
    if (this.optionsState[filterIndex].visible < this.optionsState[filterIndex].total) {
      this.optionsState[filterIndex].visible = this.optionsState[filterIndex].total
    } else {
      this.optionsState[filterIndex].visible = 3;
    }
  }

  closeBottomSheet() {
    this.bottomSheetRef.dismiss(this.data);
  }

  saveDate(dateRange: any) {
    this.data.dateRange.from = dateRange.from;
    this.data.dateRange.to = dateRange.to;
    this.getDateFilterLabel();
    this.toggleDatePicker();
  }

  clearDate() {
    this.data.dateRange.from = null;
    this.data.dateRange.to = null;
    this.getDateFilterLabel();
    this.toggleDatePicker();
  }

  toggleDatePicker() {
    this.toggleDateArrow();
    this.showDatePicker = !this.showDatePicker;
  }

  showDateFilter(): boolean {
    return this.data.dateRange !== undefined;
  }

  getDateFilterLabel(): void {
    if(isFalsyValue(this.data.dateRange))
      return;

    if(isFalsyValue(this.data.dateRange.from) && isFalsyValue(this.data.dateRange.to)) {
      this.dateFilterLabel = 'Velg dato';
      return;
    }

    if (isFalsyValue(this.data.dateRange.to)) {
      this.dateFilterLabel = format(parseISO(this.data.dateRange.from), 'dd.MM.yyyy');
    } else {
      this.dateFilterLabel = `${format(parseISO(this.data.dateRange.from), 'dd.MM.yyyy')} - ${format(parseISO(this.data.dateRange.to), 'dd.MM.yyyy')}`;
    }
  }

  toggleDateArrow(): void {
    this.isDateFilterExpanded = !this.isDateFilterExpanded;
  }
}
